import { Box } from "@chakra-ui/react";

export const Separator = () => {
  return <Box mt="5px" w="50px" h="2px" bg="brand.red"></Box>;
};
